import { Grid } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Grid width={"100%"} height={"100%"} m={5} textAlign={"center"}>
      <span>&copy; FID Candidature 2025 </span>
    </Grid>
  );
};

export default Footer;
